import { BaseProdHost, ProdHost } from "./prod";
import { BaseTestHost, TestHost } from "./test";
const HiyaBaseHost = {
  prod: BaseProdHost,
  test: BaseTestHost
};
const HiyaHostMaps = {
  prod: ProdHost,
  test: TestHost
};
export {
  HiyaBaseHost,
  HiyaHostMaps
};
